import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterBookByFeatured } from "../redux/filters/actions";

export default function FilterFeaturedBook() {
  const dispatch = useDispatch();
  const { featuredFilter } = useSelector((state) => state.filters);

  function filter(value) {
    dispatch(filterBookByFeatured(value));
  }

  return (
    <div className="flex items-center space-x-4">
      <button
        onClick={() => filter(false)}
        className={`filter-btn ${!featuredFilter ? "active-filter" : ""}`}
        id="lws-filterAll"
      >
        All
      </button>
      <button
        onClick={() => filter(true)}
        className={`filter-btn ${featuredFilter ? "active-filter" : ""}`}
        id="lws-filterFeatured"
      >
        Featured
      </button>
    </div>
  );
}
